<template>
  <div>
        <h1>Modificación a tipos de vehículo</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar tipo de vehículo"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getVehicleType"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    <template v-slot:cell(active)="row">
      <b-badge v-if="row.item.active" variant="success">Activo</b-badge>
      <b-badge v-else variant="warning">Inactivo</b-badge>
    </template>
      <template v-slot:cell(fare)="row">
        {{ row.item.fare * 100 + ' %' }}
      </template>
      <template v-slot:cell(acciones)="row">
        <router-link size="sm" :to="{ name:'updateVehicleFare', params:row.item }" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar tarifa</b-button></router-link>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getVehicleType.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_VEHICLE_TYPE = gql`
  query getVehicleType{
    getVehicleType {
      id
      chargeDiscount
      fare
      type
      active
      imageVehicle
    }
  }
`
export default {
  data() {
    return {
      getVehicleType: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true, sortDirection: 'desc' },
        // { key: 'chargeDiscount', label: 'Tipo de Cargo' },
        { key: 'fare', label: 'Tarifa' },
        { key: 'type', label: 'Tipo de vehículo' },
        // { key: 'active', label: 'Estatus' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    }
  },
  apollo: {
    getVehicleType: {
      query: GET_VEHICLE_TYPE,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getVehicleType) {
          this.totalRows = data.getVehicleType.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style>

</style>
